import { Tooltip } from '@hotjar/webapp/components/Tooltip';
import { tokens } from '@hotjar/hotsauce';
import { ContentSection } from '../SubscriptionSummary.styles';
import { Heading, InfoIcon, VatTotal } from './SubscriptionCost.styles';

interface ToolTipProps {
  subscriptionTotal: number;
  subscriptionVatRate: number;
  subscriptionVatTotal: number;
  totalWithTax: number;
  prettifyCost: (x: string | number) => string;
}

function TotalsTooltip({
  subscriptionTotal,
  subscriptionVatRate,
  subscriptionVatTotal,
  totalWithTax,
  prettifyCost,
}: ToolTipProps): JSX.Element {
  return (
    <>
      <div className="ptm pbm semibold">Amount breakdown:</div>
      <table id="bill-breakdown">
        <tbody>
          <tr>
            <td className="desc">Plans:</td>
            <td>&nbsp;</td>
            <td>{prettifyCost(subscriptionTotal)}</td>
          </tr>
          <tr className="line line-dashed">
            <td className="desc">SubTotal:</td>
            <td>&nbsp;</td>
            <td>{prettifyCost(subscriptionTotal)}</td>
          </tr>
          {!!subscriptionVatTotal && (
            <tr>
              <td className="desc">VAT ({subscriptionVatRate}%):</td>
              <td>+</td>
              <td>{prettifyCost(subscriptionVatTotal)}</td>
            </tr>
          )}
          <tr className="line">
            <td className="desc">Total:</td>
            <td>=</td>
            <td>{prettifyCost(totalWithTax)}</td>
          </tr>
        </tbody>
      </table>
    </>
  );
}

export function CostBreakdown({
  subscriptionTotal,
  subscriptionVatRate,
  subscriptionVatTotal,
  totalWithTax,
  prettifyCost,
  hasPaidPlan,
  shouldShowVatRate,
}: ToolTipProps & { hasPaidPlan: boolean; shouldShowVatRate: boolean }): JSX.Element {
  return hasPaidPlan ? (
    <ContentSection>
      <Heading>
        {prettifyCost(totalWithTax)}
        <Tooltip
          content={
            <TotalsTooltip
              subscriptionTotal={subscriptionTotal}
              subscriptionVatRate={subscriptionVatRate}
              subscriptionVatTotal={subscriptionVatTotal}
              totalWithTax={totalWithTax}
              prettifyCost={prettifyCost}
            />
          }
          appendTo="parent"
        >
          <InfoIcon icon="info" size={16} color={tokens.color.neutral_700} />
        </Tooltip>
      </Heading>
      {shouldShowVatRate && <VatTotal>{`Including ${subscriptionVatRate}% VAT`}</VatTotal>}
    </ContentSection>
  ) : (
    <ContentSection>
      <Heading>Free</Heading>
    </ContentSection>
  );
}
